export const getCurrentLocale = () => (navigator.languages && navigator.languages[0])
|| navigator.language
|| navigator.userLanguage;

const delimiter = '-'; // per ISO standard

export const LOCALE_PARTS = {
  LANGUAGE: 0,
  LOCATION: 1
};

export const getLocalePart = (locale, index) => {
  if (!locale) {
    return '';
  }
  const localePart = locale.split(delimiter)[index];
  if (!localePart) return '';

  return localePart;
};

export const getLocaleLocation = locale => getLocalePart(locale, LOCALE_PARTS.LOCATION);
export const getLocaleLanguage = locale => getLocalePart(locale, LOCALE_PARTS.LANGUAGE);

export const getCurrentLocaleLocation = () => getLocaleLocation(getCurrentLocale());
export const getCurrentLocaleLanguage = () => getLocaleLanguage(getCurrentLocale());

export default getCurrentLocale;
